import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ZkkSelectionComponent} from '../zkk-selection/zkk-selection.component';

@Component({
  selector: 'app-zkk-selection-view',
  templateUrl: './zkk-selection-view.component.html',
  styleUrls: ['./zkk-selection-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ZkkSelectionComponent]
})
export class ZkkSelectionViewComponent {}
